import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
	selector: 'ae-progress-bar',
	imports: [NgClass],
	templateUrl: './progress-bar.component.html',
	styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent {
	count = input.required<number>();
	total = input.required<number>();
	type = input<'percent' | 'count'>('percent');

	progressPercent = computed(
		() => Math.floor((this.count() / this.total()) * 100) || 0, // or in case floor returns NaN
	);
}
